import SystemPipeLineListsScreenAPI from "../services/systempipeline-lists-screen-service";
import { observable } from "mobx";
import { AppConstants } from "../../../common/APIConstants";
import moment from "moment";
import RestEndPoint from "../../../common/RestEndPoint";

class SystemPipeLineListsScreenStore {
  @observable entityData = [];
  @observable entityTypes = [];
  @observable selectedJurisdiction = null;
  @observable selectedEntityType = null;
  @observable addButtonText = "Add Pipeline";
  @observable addButtonSystemText = "Add System";
  @observable exportButtonText = "Export";

  setSelectedJurisdiction = (jurisdiction) =>
    (this.selectedJurisdiction = jurisdiction);
  setSelectedEntityType = (entityType) =>
    (this.selectedEntityType = entityType);
  setEntityData = (entityData) => (this.entityData = entityData);

  getEntityTypes = async () => {
    try {
      const response = await SystemPipeLineListsScreenAPI.getEntityTypes();

      this.entityTypes = response?.data?.map((item) => ({
        label: item,
        value: item,
      }));
    } catch (error) {
      window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
    }
  };

  getEntityData = async (
    CommonStore,
    jurisdiction = 1,
    entityType = 1
  ) => {
    if (!entityType || !jurisdiction) return;
    CommonStore.toggleLoader();
    try {
      // const requestData = {
      //   jurisdiction: jurisdiction?.value,
      //   entityType: entityType?.value,
      // };

      const requestData = {
        jurisdiction: "Plains - South",
        entityType: "System",
      };
      console.log('calllllll');
      const response = await SystemPipeLineListsScreenAPI.getEntityList(requestData);
      let entityData = response?.data?.map((item) => ({
        ...item,
        status: item.status ? "Active" : "Inactive",
      }));

      entityData = entityData.sort((a, b) =>
                a.lineName.localeCompare(b.lineName));

      this.entityData = entityData;
      CommonStore.toggleLoader();
    } catch (error) {
      CommonStore.toggleLoader();
      window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
    }
  };

  addSystemPipeLine = async (data, CommonStore) => {
    CommonStore.toggleLoader();
    try {
      const requestData = {
        ...data,
        createdBy: RestEndPoint.getCurrentUserName(),
        createdDate: new Date().toLocaleString(
          "en-US",
          { hour12: false },
          {
            timeZone: "America/Denver",
            timeZoneName: "short",
          }
        ),
      };


      await SystemPipeLineListsScreenAPI.addSystemPipeLine(requestData);
      
      await this.getEntityData(CommonStore);

      CommonStore.toggleLoader();
      
      /* CALL GET SCREEN API */
      //CommonStore.getScreens();
      CommonStore.toggleLoader();
      /* CALL GET SCREEN API */
      CommonStore.getScreens().then(() => {
        CommonStore.toggleLoader();
        //this.refreshData();
      }).catch(() =>{
        window.toastr.error(AppConstants.TOASTER_ERROR_RETRIEVE_TEXT);
        CommonStore.toggleLoader();
      });


      window.toastr.success(
        AppConstants.DIGMASTER.SYSTEMPIPELINEADD.TOAST_MESSAGES.CREATE_SUCCESS
      );
    } catch (error) {
      await this.getEntityData(CommonStore);
      CommonStore.toggleLoader();
      if (error.response.data.includes("Violation of UNIQUE KEY constraint")) {
        window.toastr.error(
          AppConstants.DIGMASTER.SYSTEMPIPELINEADD.TOAST_MESSAGES.CREATE_DUPLICATE_ERROR
        );
      } else {
        window.toastr.error(
          AppConstants.DIGMASTER.SYSTEMPIPELINEADD.TOAST_MESSAGES.CREATE_GENERIC_ERROR
        );
      }
    }
  };

  /* Add System */
  addSystem = async (data, CommonStore) => {
    CommonStore.toggleLoader();
    try {
      const requestData = {
        ...data,
        createdBy: RestEndPoint.getCurrentUserName(),
        createdDate: new Date().toLocaleString(
          "en-US",
          { hour12: false },
          {
            timeZone: "America/Denver",
            timeZoneName: "short",
          }
        ),
      };

      await SystemPipeLineListsScreenAPI.addSystem(requestData);
      CommonStore.toggleLoader();
      window.toastr.success(
        AppConstants.DIGMASTER.SYSTEMADD.TOAST_MESSAGES.CREATE_SUCCESS
      );
    } catch (error) {
      CommonStore.toggleLoader();
      if (error.response.data.includes("Violation of UNIQUE KEY constraint")) {
        window.toastr.error(
          AppConstants.DIGMASTER.SYSTEMADD.TOAST_MESSAGES.CREATE_DUPLICATE_ERROR
        );
      } else {
        window.toastr.error(
          AppConstants.DIGMASTER.SYSTEMADD.TOAST_MESSAGES.CREATE_GENERIC_ERROR
        );
      }
    }
  };

  updateEntity = async (data, CommonStore) => {
    CommonStore.toggleLoader();
    try {
      const requestData = {
        
        Status: data?.status === "Active",
        UpdatedBy: RestEndPoint.getCurrentUserName(),
        UpdatedDate: new Date().toLocaleString(
          "en-US",
          { hour12: false },
          {
            timeZone: "America/Denver",
            timeZoneName: "short",
          }
        ),
      };

      await SystemPipeLineListsScreenAPI.updateEntity(data?.id, requestData);

      await this.getEntityData(
        CommonStore
        
      );
      CommonStore.toggleLoader();
      window.toastr.success(
        AppConstants.DIGMASTER.LISTS_SCREEN.TOAST_MESSAGES.UPDATE_SUCCESS
      );
    } catch (error) {
      await this.getEntityData(
        CommonStore
      );
      CommonStore.toggleLoader();
      if (error.response.data.includes("Violation of UNIQUE KEY constraint")) {
        window.toastr.error(
          AppConstants.GAIN_LOSS.LISTS_SCREEN.TOAST_MESSAGES
            .UPDATE_DUPLICATE_ERROR
        );
      } else {
        window.toastr.error(
          AppConstants.DIGMASTER.SYSTEMPIPELINEADD.TOAST_MESSAGES
            .UPDATE_GENERIC_ERROR
        );
      }
    }
  };
}

export default new SystemPipeLineListsScreenStore();
